import assign from 'lodash/assign'
import {
  SET_AXG_DATA,
  RESET_AXG_DATA,
} from '../action-types'


const initialState = {
}

export default function AXGData(state=initialState, action) {
  switch (action.type) {
    case SET_AXG_DATA:
      // return {
      //   ...state,
      //   `${action.options.key}`: action.options.value
      // }
      state[action.options.key] = action.options.value
      return assign({}, state)
    case RESET_AXG_DATA:
      return {}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/axg-data.js